const BASE_URL ='https://sap-integration-app-dot-dbs-prod.nw.r.appspot.com';
// const BASE_URL ='https://sap-integration-app-dot-nimble-equator-282207.nw.r.appspot.com';
// const BASE_URL ='https://e85053efabd2.ngrok-free.app';
export const API_URLS = {
  API_BASE_URL:{BASE_URL},
  VRIFY_TOKEN:`${BASE_URL}/admins/verifyToken`,
  GET_SAP_PRODUCT: `${BASE_URL}/sap_products/getSapProductList`,
  GET_VARIANT_PRODUCT: `${BASE_URL}/bc_products/getVariantProductList`,
  GET_STORES: `${BASE_URL}/bc/get_stores`,
  LOGIN: `${BASE_URL}/admins/login`,
  UPDATE_BC_PRODUCT_STATUS: `${BASE_URL}/bc_products/updateProductStatus`,
  UPDATE_BC_PRODUCT: `${BASE_URL}/bc_products/updateBCProduct`,
  GET_FRONTEND_TABS: `${BASE_URL}/bc/get_fronend_tabs`,
  GET_KIT_PRODUCTS: `${BASE_URL}/kit/getKitProducts`,
  GET_CATAGORY_TREE: `${BASE_URL}/bc/get_category_tree`,
  COMPLETE_SYNC:  `${BASE_URL}/bc_products/sync_by_store`,// master bulk
  CREATE_BC_PRODUCT: `${BASE_URL}/bc_products/createBCProduct`,// master bulk
  SYNC_SELECTED_PRODUCT_INV: `${BASE_URL}/bc_products/syncSelectedBCProductsInventory`,// master bulk
  SEARCH_PRODUCT_SAP_SKU: `${BASE_URL}/bc/searchSAPProductSKU`,
  SEARCH_PRODUCT_BC_SKU: `${BASE_URL}/bc/searchProductSKU`,
  GET_ALL_CATAGORY_TREE: `${BASE_URL}/bc/get_All_store_category_tree`,// pending
  GET_ALL_SIMPLE_PRODUCTS:  `${BASE_URL}/bc_products/getSimpleProductList`,
  UPLOAD_TO_GCP_BUCKET: `${BASE_URL}/bc/uploadRemoveImgBucket`,
  UPDATE_BC_BULK_PRODUCT_STATUS: `${BASE_URL}/bc_products/updateBulkProductStatus`,
  SYNC_INVENTODY: `${BASE_URL}/bc_products/syncSelectedBCProductsInventory`,
  SYNC_SAP:`${BASE_URL}/sap_products/sync_SAP_products_api`,
  CREATE_GIFT_PRODUCT: `${BASE_URL}/bc_products/createGIFTProduct`,
  GET_BUNDLE_PRODUCTS: `${BASE_URL}/bc_products/getBundleProductList`,
  UPDATE_ENRICH: `${BASE_URL}/bc_products/updateBulkProduct`,  
  GET_FRONT_END_ATTRIBUTES:`${BASE_URL}/attributes/getFrontendAttributes`,  
  ADD_ATTRIBUTE_VALUE:`${BASE_URL}/attributes/addAttributesValue`,
  UPDATE_ATTRIBUTES: `${BASE_URL}/attributes/updateAttributes`,
  ADD_ATTRIBUTES: `${BASE_URL}/attributes/addAttributes`,
  GET_LOGS: `${BASE_URL}/admins/getlogs`,
  IMPOT_EXCEL: `${BASE_URL}/bc_products/import_bc_products`,
  BULK_PRICE_UPDATE:`${BASE_URL}/bc_products/updateBulkProductPrice`,  
}
export default API_URLS;